import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  maxStudentLicenses: number | undefined;
  usedStudentLicenses: number | undefined;
  maxInstructorLicenses?: number | undefined;
  usedInstructorLicenses?: number | undefined;
  maxAdminLicenses?: number | undefined;
  usedAdminLicenses?: number | undefined;
  loading: boolean;
}


import { computed } from 'vue';

import { modals } from '@modals';

declare module 'vue/types/vue' {
  export interface Vue {
    CardSiteLicenses: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardSiteLicenses' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    maxStudentLicenses: null,
    usedStudentLicenses: null,
    maxInstructorLicenses: null,
    usedInstructorLicenses: null,
    maxAdminLicenses: null,
    usedAdminLicenses: null,
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  maxStudentLicenses: number | undefined;
  usedStudentLicenses: number | undefined;
  maxInstructorLicenses?: number | undefined;
  usedInstructorLicenses?: number | undefined;
  maxAdminLicenses?: number | undefined;
  usedAdminLicenses?: number | undefined;
  loading: boolean;
};

/**
 * `CardStat` component properties.
 */


const title = 'SITE LICENSE USAGE';

const successVariantValue = 90;
const warningVariantValue = 100;

function getLicenseVariant(max: number, used: number) {
  if (!max || !used) {
    return 'success';
  }

  const percentage = (used / max) * 100;

  if (percentage < successVariantValue) {
    return 'success';
  } else if (percentage <= warningVariantValue) {
    return 'warning';
  } else {
    return 'danger';
  }
}

const studentLicenseVariant = computed(() => {
  if (!props.maxStudentLicenses || !props.usedStudentLicenses) {
    return 'success';
  }

  return getLicenseVariant(props.maxStudentLicenses, props.usedStudentLicenses);
});

const addMoreLicenses = () => {
  void modals.util.generalInfo({
    title: 'Add More Licenses',
    text: 'To add more licenses, contact your account manager or email us at sales@littlearms.com',
  });
};

return { __sfc: true,props, title, successVariantValue, warningVariantValue, getLicenseVariant, studentLicenseVariant, addMoreLicenses }
}

})